"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeDATE = function CategoryCodeDATE(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeDATE"), _react.default.createElement("path", {
    d: "M12.656,3.679H3.124a.409.409,0,0,0-.409.409v9.187a.409.409,0,0,0,.721.265l1.74-2.046a.4.4,0,0,1,.311-.144h7.169a.409.409,0,0,0,.409-.409V4.088A.409.409,0,0,0,12.656,3.679ZM9.889,7.964,8.022,9.748a.191.191,0,0,1-.264,0l-1.87-1.79a1.118,1.118,0,0,1-.083-.077c-.035-.036-.09-.1-.166-.2a2.628,2.628,0,0,1-.2-.29,1.8,1.8,0,0,1-.16-.359A1.3,1.3,0,0,1,5.2,6.626,1.355,1.355,0,0,1,5.585,5.6a1.448,1.448,0,0,1,1.052-.369,1.192,1.192,0,0,1,.379.064,1.57,1.57,0,0,1,.36.172c.111.073.206.141.286.2a2.935,2.935,0,0,1,.228.2,2.935,2.935,0,0,1,.228-.2c.08-.063.175-.131.286-.2a1.57,1.57,0,0,1,.36-.172,1.192,1.192,0,0,1,.379-.064A1.448,1.448,0,0,1,10.2,5.6a1.355,1.355,0,0,1,.381,1.022A1.938,1.938,0,0,1,9.889,7.964Z"
  })));
};

var _default = CategoryCodeDATE;
exports.default = _default;